module.exports = __webpack_public_path__ + "static/media/fashion-image-1@3x.3afb8c7d.jpg";